import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import { api } from "../../redux/reducers/apiSlice";
import { clearToken } from "../../redux/reducers/authSlice";
import * as Sentry from "@sentry/react";

/**
 * Hook for signing out user
 * Can be used inside or outside Router context
 * If used outside Router, will use window.location for navigation
 */
const useSignout = () => {
    const dispatch = useDispatch();

    const signOut = async () => {
        try {
          dispatch(api.util.resetApiState());
          dispatch(clearToken()); // resetting api after calling Auth.signout will break
          await Auth.signOut();
          
          // Always use window.location - works everywhere and causes full page reload
          // This ensures state is completely cleared
          window.location.href = "/";
        } catch (error) {
          Sentry.captureException(error);
          console.error("error signing out: ", error);
          // Always fallback to window.location on error
          window.location.href = "/";
        }
      };

    return {
        signOut
    }
}

export default useSignout